import { stockRequestBody } from "./stockContext";


import { apiFetch } from "./apiFetch";

async function parseStockNewsActionResponse(resp, fallbackMessage) {
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data.message || data.error || fallbackMessage);
  }
  return data;
}

export async function fetchStockNewsActionItems(serverUrl, stockSession) {
  const data = await parseStockNewsActionResponse(
    await apiFetch(`${serverUrl}/listStockNewsActionItems`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession)),
    }),
    "Failed to load action items"
  );
  return Array.isArray(data.actionItems) ? data.actionItems : [];
}

export async function createStockNewsActionItem(serverUrl, stockSession, title, { labels } = {}) {
  const body = { title, status: "open" };
  if (labels !== undefined) body.labels = labels;
  const data = await parseStockNewsActionResponse(
    await apiFetch(`${serverUrl}/createStockNewsActionItem`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession, body)),
    }),
    "Failed to create action item"
  );
  return data.actionItem;
}

export async function updateStockNewsActionItem(serverUrl, stockSession, { actionItemId, title, status, labels }) {
  const payload = { actionItemId };
  if (title != null) payload.title = title;
  if (status != null) payload.status = status;
  if (labels !== undefined) payload.labels = labels;
  const data = await parseStockNewsActionResponse(
    await apiFetch(`${serverUrl}/updateStockNewsActionItem`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession, payload)),
    }),
    "Failed to update action item"
  );
  return data.actionItem;
}

export async function renameStockNewsActionItemLabel(serverUrl, stockSession, { oldLabel, newLabel }) {
  const data = await parseStockNewsActionResponse(
    await apiFetch(`${serverUrl}/renameStockNewsActionItemLabel`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession, { oldLabel, newLabel })),
    }),
    "Failed to rename label"
  );
  return typeof data.modifiedCount === "number" ? data.modifiedCount : 0;
}

export async function removeStockNewsActionItemLabel(serverUrl, stockSession, label) {
  const data = await parseStockNewsActionResponse(
    await apiFetch(`${serverUrl}/removeStockNewsActionItemLabel`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession, { label })),
    }),
    "Failed to remove label"
  );
  return typeof data.modifiedCount === "number" ? data.modifiedCount : 0;
}

export async function duplicateStockNewsActionItem(serverUrl, stockSession, actionItemId) {
  const data = await parseStockNewsActionResponse(
    await apiFetch(`${serverUrl}/duplicateStockNewsActionItem`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession, { actionItemId })),
    }),
    "Failed to duplicate action item"
  );
  return data.actionItem;
}

export async function deleteStockNewsActionItem(serverUrl, stockSession, actionItemId) {
  await parseStockNewsActionResponse(
    await apiFetch(`${serverUrl}/deleteStockNewsActionItem`, {
      method: "POST",
      body: JSON.stringify(stockRequestBody(stockSession, { actionItemId })),
    }),
    "Failed to delete action item"
  );
}
